import styled from "styled-components";
import { BodyDefault } from "../../../../../components/typography/styled";
type ImgProps = {
  active?:boolean;
}
export const Container = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  width: 100%;
  padding-right: 20px;
  min-width: 0;
  max-width: 100%;

  svg {
    max-width: 100%;
  }
`
export const SelectWrapper = styled.div`
  /* display: flex; */
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  /* min-height: 144px; */
  border: ${({theme}) => `1px solid ${theme.palette[20]}`};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom:20px;
`
export const SelectRow = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  justify-content: space-between;
  min-width: 0;

  > div {
    min-width: 0;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;

    > div:first-child {
      flex: 1 1 240px;
    }
  }
`
export const RefreshWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 12px;
  margin-left: 8px;
  gap:8px;
  height: 52px;
  &:hover{
    cursor: pointer;
  }

`
export const RefreshText = styled(BodyDefault)`
  color:${({theme}) => theme.primary[600]};
`
export const RotateImg = styled.img<ImgProps>`
  animation: ${({active}) => active ? 'rotating 0.8s linear infinite' : ''};
  @keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`

export const ClearButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-left: 8px;
  margin-top: 25px;
  cursor: pointer;
  background-color: ${({theme}) => theme.palette[10]};
  flex: 0 0 40px;
  border: ${({theme}) => `1px solid ${theme.palette[20]}`};
  transition: all 0.2s ease;
  &:hover {
    background-color: ${({theme}) => theme.palette[20]};
  }
  img {
    width: 16px;
    height: 16px;
    opacity: 0.6;
  }
`
